import React, { useEffect } from 'react';
import classes from '../OpeningHours/OpeningHours.module.css';

import DeleteButton from '../../../../components/UI/Buttons/DeleteButton';
import { weekdayFromNumberToString } from '../../../../utils/calendarUtils';
import { useAppDispatch, useAppSelector } from '../../../../store/store';
import {
  IWorkingHours,
  fetchWorkingHours,
  selectWorkingHours,
  updateWorkingHoursState,
} from '../../../../store/slices/calendarAndSlots';

import WorkingHoursModal from '../../Modals/WorkingHours/WorkingHoursModal';
import { useTranslation } from '../../../../hooks/useTranslations';

type Props = {
  isModalOpen: boolean;
  onModalClose: () => void;
};

const WorkingHours: React.FC<Props> = ({ isModalOpen, onModalClose }) => {
  const dispatch = useAppDispatch();
  const { translations } = useTranslation();
  const workingHours = useAppSelector<IWorkingHours[]>(selectWorkingHours);

  const fetchData = async () => {
    await dispatch(fetchWorkingHours());
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleDelete = async (item: any) => {
    const found = workingHours.find((e: any) => e == item);
    const filteredData = [...workingHours].filter((item) => item !== found);
    let dataToPost = [filteredData];
    dispatch(updateWorkingHoursState(dataToPost[0]));
  };

  return (
    <div>
      {workingHours ? (
        <div className={classes.container}>
          <div className={classes.mainContainer}>
            <text className={classes.headerText}>{translations('day')}</text>
            <text className={classes.headerText}>{translations('from')}</text>
            <text className={classes.headerText}>{translations('to')}</text>
          </div>
          <div>
            {workingHours?.map((item: IWorkingHours, index: number) => {
              return (
                <div key={index} className={classes.flatlistContainer}>
                  <div className={classes.textContainer}>
                    <text className={classes.text}>
                      {translations(weekdayFromNumberToString(item?.weekday_id))}
                    </text>
                  </div>
                  <div className={classes.textContainer}>
                    <text className={classes.text}>{item.start_time}</text>
                  </div>
                  <div className={classes.textContainer}>
                    <text className={classes.text}>{item.end_time}</text>
                  </div>
                  <div className={classes.button}>
                    <DeleteButton onClick={() => handleDelete(item)} />
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      ) : (
        <div>{translations('no.working.hours')}</div>
      )}

      <WorkingHoursModal isOpen={isModalOpen} onClose={onModalClose} />
    </div>
  );
};

export default WorkingHours;
